import { useNavigate, useParams } from "react-router-dom";
import VideoContainer from "../../components/videoCourseList/VideoContainer";
import { useTrainingDetailsQuery } from "../../hooks/queries/use-training-details-query";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { useCreateOrder } from "../../hooks/use-create-order";
import { useCaptureOrderMutation } from "../../hooks/mutations/use-capture-order-mutation";

function TrainingCourse() {
  const { mutate: captureOrder } = useCaptureOrderMutation();
  const params = useParams();
  const trainingId = Number(params.trainingId);
  const createOrder = useCreateOrder(trainingId);

  const navigate = useNavigate();

  const {
    data: training,
    isError,
    isLoading,
  } = useTrainingDetailsQuery(trainingId);

  if (!trainingId || (!isLoading && isError)) {
    navigate("/trainings");
    return null;
  }

  return (
    <div className="mx-auto min-h-screen mt-32 lg:px-8 box-border">
      {training?.locked && (
        <div className="max-w-2xl mx-auto h-28 text-baseBlue rounded-2xl px-2 lg:px-4 relative">
          <div className="flex flex-col">
            <div className="text-lg text-center ">
              Total price of the full course:
              <span className=" font-bold pl-1">
                {training?.price}$
              </span>
            </div>
              <PayPalButtons
                className="w-auto sm:w-auto z-0 px-4"
                createOrder={createOrder}
                style={{
                  layout: "horizontal",
                  color: "blue",
                  shape: "rect",
                  label: "buynow",
                }}
                onError={(err) => console.error(err)}
                onApprove={(data) => {
                  const paymentId = data.paymentID;
                  captureOrder(paymentId);
                }}
              />
            </div>
          </div>
      )}
      <VideoContainer training={training} />
    </div>
  );
}

export default TrainingCourse;
